import React from "react";

interface DateRangePickerProps {
  dateFrom: string;
  dateTo: string;
  onDateFromChange: (value: string) => void;
  onDateToChange: (value: string) => void;
  label?: string;
}

export default function DateRangePicker({
  dateFrom,
  dateTo,
  onDateFromChange,
  onDateToChange,
  label,
}: DateRangePickerProps) {
  return (
    <div className="flex flex-col sm:flex-row gap-2 items-start sm:items-center">
      {label && (
        <span className="text-sm font-medium text-gray-600 whitespace-nowrap">
          {label}
        </span>
      )}
      <div className="flex items-center gap-2">
        <input
          type="date"
          value={dateFrom}
          onChange={(e) => onDateFromChange(e.target.value)}
          className="border border-gray-300 rounded-lg px-3 py-1.5 text-sm text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          aria-label="From date"
        />
        <span className="text-gray-400 text-sm">to</span>
        <input
          type="date"
          value={dateTo}
          onChange={(e) => onDateToChange(e.target.value)}
          min={dateFrom || undefined}
          className="border border-gray-300 rounded-lg px-3 py-1.5 text-sm text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          aria-label="To date"
        />
        {/* These bounds are UTC calendar dates, because that is what the
            endpoints behind them are: the value becomes a DynamoDB partition
            key directly, and the collectors key those partitions on the UTC
            date of each event. Saying so is the difference between a window
            the reader can reason about and one that is quietly a few hours
            off the days on the labels. Timestamps in the results below are
            still shown in the reader's configured timezone. */}
        <span className="text-xs text-gray-400 whitespace-nowrap">UTC</span>
      </div>
    </div>
  );
}
